var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgZoneIconCode(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 29,
    viewBox: "0 0 29 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.17352 21.2542C11.0952 25.1758 17.4534 25.1758 21.375 21.2542C25.2966 17.3326 25.2966 10.9744 21.375 7.05273L7.17352 21.2542Z",
    fill: "#FF8900"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.3265 7.10126C17.4049 3.17963 11.0466 3.17963 7.125 7.10125C3.20337 11.0229 3.20337 17.3811 7.125 21.3027L21.3265 7.10126Z",
    fill: "#FFA922"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5472 18.1C14.0139 18.1 13.5172 18.0133 13.0572 17.84C12.6039 17.66 12.2072 17.41 11.8672 17.09C11.5339 16.7633 11.2739 16.38 11.0872 15.94C10.9005 15.5 10.8072 15.02 10.8072 14.5C10.8072 13.98 10.9005 13.5 11.0872 13.06C11.2739 12.62 11.5372 12.24 11.8772 11.92C12.2172 11.5933 12.6139 11.3433 13.0672 11.17C13.5205 10.99 14.0172 10.9 14.5572 10.9C15.1305 10.9 15.6539 11 16.1272 11.2C16.6005 11.3933 17.0005 11.6833 17.3272 12.07L16.4872 12.86C16.2339 12.5867 15.9505 12.3833 15.6372 12.25C15.3239 12.11 14.9839 12.04 14.6172 12.04C14.2505 12.04 13.9139 12.1 13.6072 12.22C13.3072 12.34 13.0439 12.51 12.8172 12.73C12.5972 12.95 12.4239 13.21 12.2972 13.51C12.1772 13.81 12.1172 14.14 12.1172 14.5C12.1172 14.86 12.1772 15.19 12.2972 15.49C12.4239 15.79 12.5972 16.05 12.8172 16.27C13.0439 16.49 13.3072 16.66 13.6072 16.78C13.9139 16.9 14.2505 16.96 14.6172 16.96C14.9839 16.96 15.3239 16.8933 15.6372 16.76C15.9505 16.62 16.2339 16.41 16.4872 16.13L17.3272 16.93C17.0005 17.31 16.6005 17.6 16.1272 17.8C15.6539 18 15.1272 18.1 14.5472 18.1Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgZoneIconCode);
export default __webpack_public_path__ + "static/media/zone_icon_code.b95048a16ac084d6f2aab994a69b186b.svg";
export { ForwardRef as ReactComponent };